/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_No_Artifacts_Create_PromptInputs */



/**
* | output |
* | --- |
* | "No artifacts yet. Create one to get started." |
*
* @param {Artifact_No_Artifacts_Create_PromptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_no_artifacts_create_prompt = /** @type {((inputs?: Artifact_No_Artifacts_Create_PromptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_No_Artifacts_Create_PromptInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Artefakte. Erstelle eines, um zu beginnen.")
	return /** @type {LocalizedString} */ ("No artifacts yet. Create one to get started.")
});